import AppExperienceFa from "./AppExperience-fa.json";
import AppExperienceEn from "./AppExperience-en.json";
import AppExperienceAr from "./AppExperience-ar.json";
import AppExperienceTr from "./AppExperience-tr.json";

import DownloadDividerFa from "./DownloadDivider-fa.json";
import DownloadDividerEn from "./DownloadDivider-en.json";
import DownloadDividerAr from "./DownloadDivider-ar.json";
import DownloadDividerTr from "./DownloadDivider-tr.json";

import DownloadHeroSectionFa from "./DownloadHeroSection-fa.json";
import DownloadHeroSectionEn from "./DownloadHeroSection-en.json";
import DownloadHeroSectionAr from "./DownloadHeroSection-ar.json";
import DownloadHeroSectionTr from "./DownloadHeroSection-tr.json";

import FAQFa from "./FAQ-fa.json";
import FAQEn from "./FAQ-en.json";
import FAQAr from "./FAQ-ar.json";
import FAQTr from "./FAQ-tr.json";

import HealthMonitoringFa from "./HealthMonitoring-fa.json";
import HealthMonitoringEn from "./HealthMonitoring-en.json";
import HealthMonitoringAr from "./HealthMonitoring-ar.json";
import HealthMonitoringTr from "./HealthMonitoring-tr.json";

import InteractiveSetupProcessFa from "./InteractiveSetupProcess-fa.json";
import InteractiveSetupProcessEn from "./InteractiveSetupProcess-en.json";
import InteractiveSetupProcessAr from "./InteractiveSetupProcess-ar.json";
import InteractiveSetupProcessTr from "./InteractiveSetupProcess-tr.json";

import ModernAppStoreButtonsFa from "./ModernAppStoreButtons-fa.json";
import ModernAppStoreButtonsEn from "./ModernAppStoreButtons-en.json";
import ModernAppStoreButtonsAr from "./ModernAppStoreButtons-ar.json";
import ModernAppStoreButtonsTr from "./ModernAppStoreButtons-tr.json";

import ModernNoticeBoxFa from "./ModernNoticeBox-fa.json";
import ModernNoticeBoxEn from "./ModernNoticeBox-en.json";
import ModernNoticeBoxAr from "./ModernNoticeBox-ar.json";
import ModernNoticeBoxTr from "./ModernNoticeBox-tr.json";

import UserPersonasFa from "./UserPersonas-fa.json";
import UserPersonasEn from "./UserPersonas-en.json";
import UserPersonasAr from "./UserPersonas-ar.json";
import UserPersonasTr from "./UserPersonas-tr.json";

import HealthMonitoringGraphsFa from "../graphs/HealthMonitoringGraphs-fa.json";
import HealthMonitoringGraphsEn from "../graphs/HealthMonitoringGraphs-en.json";
import HealthMonitoringGraphsAr from "../graphs/HealthMonitoringGraphs-ar.json";
import HealthMonitoringGraphsTr from "../graphs/HealthMonitoringGraphs-tr.json";

import CircularFeatureOrbitFa from "../../locales/CircularFeatureOrbit-fa.json";
import CircularFeatureOrbitEn from "../../locales/CircularFeatureOrbit-en.json";
import CircularFeatureOrbitAr from "../../locales/CircularFeatureOrbit-ar.json";
import CircularFeatureOrbitTr from "../../locales/CircularFeatureOrbit-tr.json";

export const downloadLocales = {
    fa: {
        AppExperience: AppExperienceFa,
        DownloadDivider: DownloadDividerFa,
        DownloadHeroSection: DownloadHeroSectionFa,
        FAQ: FAQFa,
        HealthMonitoring: HealthMonitoringFa,
        InteractiveSetupProcess: InteractiveSetupProcessFa,
        ModernAppStoreButtons: ModernAppStoreButtonsFa,
        ModernNoticeBox: ModernNoticeBoxFa,
        UserPersonas: UserPersonasFa,
        HealthMonitoringGraphs: HealthMonitoringGraphsFa,
        CircularFeatureOrbit: CircularFeatureOrbitFa,
    },
    en: {
        AppExperience: AppExperienceEn,
        DownloadDivider: DownloadDividerEn,
        DownloadHeroSection: DownloadHeroSectionEn,
        FAQ: FAQEn,
        HealthMonitoring: HealthMonitoringEn,
        InteractiveSetupProcess: InteractiveSetupProcessEn,
        ModernAppStoreButtons: ModernAppStoreButtonsEn,
        ModernNoticeBox: ModernNoticeBoxEn,
        UserPersonas: UserPersonasEn,
        HealthMonitoringGraphs: HealthMonitoringGraphsEn,
        CircularFeatureOrbit: CircularFeatureOrbitEn,
    },
    ar: {
        AppExperience: AppExperienceAr,
        DownloadDivider: DownloadDividerAr,
        DownloadHeroSection: DownloadHeroSectionAr,
        FAQ: FAQAr,
        HealthMonitoring: HealthMonitoringAr,
        InteractiveSetupProcess: InteractiveSetupProcessAr,
        ModernAppStoreButtons: ModernAppStoreButtonsAr,
        ModernNoticeBox: ModernNoticeBoxAr,
        UserPersonas: UserPersonasAr,
        HealthMonitoringGraphs: HealthMonitoringGraphsAr,
        CircularFeatureOrbit: CircularFeatureOrbitAr,
    },
    tr: {
        AppExperience: AppExperienceTr,
        DownloadDivider: DownloadDividerTr,
        DownloadHeroSection: DownloadHeroSectionTr,
        FAQ: FAQTr,
        HealthMonitoring: HealthMonitoringTr,
        InteractiveSetupProcess: InteractiveSetupProcessTr,
        ModernAppStoreButtons: ModernAppStoreButtonsTr,
        ModernNoticeBox: ModernNoticeBoxTr,
        UserPersonas: UserPersonasTr,
        HealthMonitoringGraphs: HealthMonitoringGraphsTr,
        CircularFeatureOrbit: CircularFeatureOrbitTr,
    },
};
